import t from 'tcomb';
import Validation_Monad from './Validation_Monad';

const Bool_Schema = t.struct({
  any: t.maybe(t.list(t.Bool))
}, 'Bool_Schema');

Bool_Schema.prototype.validate = function(b: t.Boolean) {
  var actions = [];
  actions.push(Validation_Monad.bool);
  if (!t.Nil.is(this.any)) {
    actions.push(Validation_Monad.any(this.any, false));
  }
  return Validation_Monad.pipe(b, actions);
};
module.exports = Bool_Schema;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Bool_Schema.js
 **/